<template>
  <v-card outlined light class="rounded-md">
    <v-container fluid class="pa-0" style="background-color: #45e09e">
      <v-row no-gutters>
        <v-col cols="auto" class="pa-6" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-0"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-information</v-icon
              >
              Information
            </span>
          </v-card-title>
        </v-col>
        <v-spacer></v-spacer>
        <v-col v-if="false" cols="auto" class="px-6 py-3" align-self="center">
          <v-btn text icon color="white" @click="$emit('addNewIngestor')">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-col class="px-6 py-4">
      <v-row v-for="alert in informationAlerts" :key="alert.key" no-gutters>
        <v-col cols="auto" class="py-1">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div
                style="display: flex; align-items: center; margin-left: -6px"
                class="metric-title"
                v-bind="attrs"
                v-on="on"
              >
                <span
                  style="
                    font-family: Inter;
                    font-size: 0.875rem;
                    font-weight: 600;
                    margin-right: 4px;
                  "
                >
                  {{ alert.metric.Title }}
                </span>
                <v-icon
                  v-if="alert.metric.Can_Alert"
                  small
                  :color="
                    hasActiveNotification(alert) ? 'hsl(0, 87%, 59%)' : 'black'
                  "
                  :style="{
                    opacity:
                      getBellIcon(alert) === 'mdi-bell-off-outline'
                        ? '0.3'
                        : '1',
                  }"
                >
                  {{ getBellIcon(alert) }}
                </v-icon>
              </div>
            </template>
            <span>{{ alert.metric.Description }}</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-1">
          <span
            class="copyable-value"
            style="
              font-family: Inter;
              font-size: 0.875rem;
              font-weight: 400;
              white-space: nowrap;
            "
            @click="
              copyToClipboard(
                $store.state.metrics.metric[alert.id],
                alert.metric.Title
              )
            "
          >
            {{ formatValue(alert) }}
          </span>
        </v-col>
      </v-row>
    </v-col>
    <v-snackbar v-model="showToast" :timeout="2000" bottom>
      {{ toastMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
    informationAlerts: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showToast: false,
      toastMessage: '',
    };
  },
  computed: {
    hasActiveAlert() {
      const alerts = this.node?.alerts || [];
      return (metricName) => {
        return alerts.some(
          (alert) => alert.metric === metricName && alert.condition !== ''
        );
      };
    },
    isAlertSilenced() {
      const alerts = this.node?.alerts || [];
      return (metricName) => {
        const matchingAlert = alerts.find(
          (alert) => alert.metric === metricName && alert.condition !== ''
        );
        return matchingAlert?.is_silenced || false;
      };
    },
  },
  methods: {
    truncateChainId(chainId) {
      if (!chainId || chainId.length <= 32) return chainId;
      return `${chainId.slice(0, 16)}...${chainId.slice(-16)}`;
    },
    formatValue(alert) {
      const value = this.$store.state.metrics.metric[alert.id];
      if (alert.metric.Name === 'Chain_Id') {
        return this.truncateChainId(value);
      }
      return value;
    },
    handleValueCopied(message) {
      this.toastMessage = message;
      this.showToast = true;
    },
    hasActiveNotification(alert) {
      const notifications = this.$store.state.notifications.notifications;
      const metricName = `${alert.metric.Module}/${alert.metric.Name}`;
      return notifications.some(
        (notification) =>
          notification.source === this.node.id &&
          notification.metric === metricName &&
          !notification.archived &&
          !notification.cleared
      );
    },
    getBellIcon(alert) {
      const metricName = `${alert.metric.Module}/${alert.metric.Name}`;
      if (this.hasActiveNotification(alert)) {
        return this.isAlertSilenced(metricName)
          ? 'mdi-bell-sleep'
          : 'mdi-bell-ring';
      }
      if (this.hasActiveAlert(metricName)) {
        return this.isAlertSilenced(metricName)
          ? 'mdi-bell-sleep-outline'
          : 'mdi-bell-outline';
      }
      return 'mdi-bell-off-outline';
    },
    copyToClipboard(text, fieldName) {
      if (!text) return;
      const originalValue =
        fieldName === 'Chain ID'
          ? this.$store.state.metrics.metric[
              this.informationAlerts.find((a) => a.metric.Name === 'Chain_Id')
                .id
            ]
          : text;

      navigator.clipboard
        .writeText(originalValue.toString())
        .then(() => {
          this.handleValueCopied(`${fieldName} copied to clipboard`);
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    },
  },
};
</script>

<style>
.metric-title {
  cursor: help;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.metric-title:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.copyable-value {
  cursor: pointer;
}

.copyable-value:hover {
  opacity: 0.7;
}
</style>
